const QuickMenu = () =>
  import(/* webpackChunkName: "QuickMenu" */ './Dialogs/QuickMenu')
const UserMenu = () =>
  import(/* webpackChunkName: "UserMenu" */ './Dialogs/UserMenu')
const VTable = () => import(/* webpackChunkName: "VTable" */ './Table/VTable')
const Panel = () => import(/* webpackChunkName: "Panel" */ './Panel/Panel')
const FormText = () => import(/* webpackChunkName: "FormText" */ './Form/Text')
const Alert = () => import(/* webpackChunkName: "Alert" */ './Alert/Alert')
const VBtn = () => import(/* webpackChunkName: "VBtnWrapper" */ './Button/VBtn')
const FormTextPassword = () =>
  import(/* webpackChunkName: "FormTextPassword" */ './Form/TextPassword')
const FormWrapper = () => import(/* webpackChunkName: "FormWrapper" */ './Form/Form')
const FeedbackChannel = () =>
  import(/*webkacChunkName: "FeedbackChannel" */ './FeedbackChannel/FeedbackChannel')

export default {
  Alert,
  VBtn,
  QuickMenu,
  UserMenu,
  FormText,
  FormTextPassword,
  VTable,
  Panel,
  FormWrapper,
  FeedbackChannel,
}
